
export const useFeature = (name : any) => {
    // get from local storage by name
    const item = window.localStorage.getItem(name);
    return  item === 'True' || item === 'true' ? true : false;
 }

export const PAYMENT_LOGOS: Record<string, string> = {
  cashapp: "/payment-logos/cashapp.svg",
  amex: "/payment-logos/ccAmex.svg",
  applepay: "/payment-logos/ccApplepay.svg",
  discover: "/payment-logos/ccDiscover.svg",
  mastercard: "/payment-logos/ccMastercard.svg",
  paypal: "/payment-logos/ccPaypal.svg",
  visa: "/payment-logos/ccVisa.svg",
  stripe: "/payment-logos/stripe.svg",
  link: "/payment-logos/ccLink.svg",
  klarna: "/payment-logos/ccKlarna.png",
  affirm: "/payment-logos/ccAffirm.svg"
};
